import React from "react";
import { Grid } from "semantic-ui-react";
import { socket } from "../../../../lib/socketio";
import _ from "lodash";

import { useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentPLC, setUserArray } from "../../../../actions/headerActions";
import RequestAccessModal from "../../../RequestAccess/RequestAccessModal";
import { setUser } from "../../../../actions/navActions";

const IOCheckMacro_MAIN = ({ title }) => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);

  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const [pop, setPop] = React.useState(false);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    socket.emit("get tag names", [{ display_id: 7 }, { display_id: 1 }]);
    socket.on("receive tag names", (data) => {
      settags(data.tags_data);
    });
    return () => {
      socket.removeAllListeners();
    };
  }, [tags]);

  const ids = tags.map((t) => t.id);

  const IOCheckTags = tags.flatMap((t) =>
    t.tag_display_subgroup === "P100 UNSATISFIED INTERLOCKS" ? [t] : [],
  );

  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
          `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data]);

  const NState = data[9102];

  // TODO : PAFC P300 Interlock Condition -> need to update
  const GetILTag = (id, value) => {
    const HECond = data[8292];
    const LPGSelect = data[8309];
    if (value <= data[10277] && id === 463)
      return "TE001 < P30 TH"; //SLIM_TE001_P30
    else if (NState < 8 && id === 7102) return "ANODCONF < ANODCONF_N6";
    else if (value === 0 && id === 7588) return "PS700 = 0";
    else if (value === 1 && id === 8554) return "PCS_FSWERROR = 1";
    else if (value === 0 && id === 8702) return "TS110 = 0";
    else if (value === 0 && id === 7580) return "POWER SUPPLY = 0";
    else if (id === 7504) {
      if (value === 1 && data[8307] === 0)
        return "FS160 = 1 & KOREA FAN160 = 0";
      else if (value === 0 && data[8307] === 1)
        return "FS160 = 0 & KOREA FAN160 = 1";
    } else if (value === 1 && id === 7232) return "LEAK INDICATOR = 1";
    else if (value <= data[10174] && id === 7240)
      return "LT450FT < P30 TH"; // SLIM_LT450FT_P30
    else if (value === 1 && id === 7105) return "AT160LATCH = 1";
    else if (value === 1 && id === 7464) return "CV000STATUS = 1";
    else if (value === 0 && HECond === 1 && id === 7732) return "ZS0441 = 0";
    else if (value >= data[10165] && id === 135)
      return "LT400 > P30 TH"; // SLIM_LT400_P30
    else if (value > data[10157] && id === 74)
      return "CT430 > 1.25uS"; // SLIM_CT430_P30
    else if (value > data[10158] && id === 80)
      return "CT450 > 1uS"; // SLIM_CT450_P30
    else if (value < -0.1 && id === 135) return "LT400 > P30TH";
    else if (value === -999 && id === 12823) return "CP_TE800FT = -999";
    else if ((value < -2 || value > 10) && id === 150)
      return "-2 <CM001> 10"; // FR P30 Sensor Check
    else if ((value < -0.1 || value > 10) && id === 97)
      return "-0.1 <FT012> 10";
    else if ((value < -0.1 || value > 2.5) && id === 74)
      return "-0.1 <CT430> 2.5";
    else if ((value < -0.1 || value > 1.0) && id === 80)
      return "-0.1 <CT450> 1.0";
    else if ((value < 150 || value > 370) && id === 7305)
      return "150 <CP_TE005FT> 370";
    else if ((value < -200 || value > 700) && id === 612)
      return "-200 <TE900> 700";
    else if ((value < -0.1 || value > 10) && id === 100)
      return "-0.1 <FT140> 10";
    else if ((value < 100 || value > 200) && id === 466)
      return "100 <TE002> 200";
    else if ((value < 0 || value > 700) && id === 469) return "0 <TE003> 700";
    else if ((value < 0 || value > 700) && id === 463) return "0 <TE001> 700";
    else if ((value < 0 || value > 700) && id === 481) return "0 <TE010> 700";
    else if ((value < -50 || value > 70) && id === 520)
      return "-50 <TE150B> 70";
    else if ((value < 0 || value > 700) && id === 527) return "0 <TE310> 700";
    else if ((value < 0 || value > 300) && id === 538) return "0 <TE330> 300";
    else if ((value < 0 || value > 250) && id === 557) return "0 <TE431> 250";
    else if (id === 599) {
      if ((value < 0 || value > 300) && (data[8294] === 1 || data[8296] === 1))
        return "0 <TE831> 300";
      else if (
        (value < 0 || value > 300) &&
        data[8294] === 0 &&
        data[8296] === 0
      )
        return "0 <TE012H> 300";
    } else if ((value < 0 || value > 300) && id === 602) return "0 <TE832> 300";
    else if ((value < 0 || value > 700) && id === 624) return "0 <TE910> 700";
    else if ((value < -2 || value > 102) && id === 779) return "-2 <ZT010> 102";
    else if ((value < 0 || value > 138) && id === 368) return "0 <PT012> 138";
    else if (id === 371) {
      if ((value < 0 || value > 1000) && data[8287] === 1)
        return "FCV500 & 0 <PT510> 1000";
      else if (value >= 0 && value <= 1000 && data[8287] === 0)
        return "NOT FCV500 & PT510 IN RANGE";
    } else if (LPGSelect === 2) {
      if (value === 1 && id === 7107) return "AT161 LATCH = 0";
      else if (value === 1 && id === 7109) return "AT162 LATCH = 0";
      else if (value < data[10287] && id === 511) return "TE030 < P30TH_LPG";
      else if ((value < 0 || value > 700) && id === 627) return "0 <TE911> 700";
      else if ((value < 0 || value > 700) && id === 630) return "0 <TE912> 700";
      else if ((value < 0 || value > 700) && id === 478)
        return "TE006 <> RANGE";
    } else if (LPGSelect === 1) {
      if (value === 1 && id === 7107) return "AT161 LATCH = 0";
      else if (value === 1 && id === 7109) return "AT162 LATCH = 0";
      else if ((value < 0 || value > 700) && id === 627) return "0 <TE911> 700";
      else if ((value < 0 || value > 700) && id === 630) return "0 <TE912> 700";
      else if (value < data[10288] && id === 511) return "TE030 < P30TH_LPG";
    }
  };

  const ILColumn = _.times(1, (i) =>
    IOCheckTags.map((r) => (
      <Grid.Column
        key={r.id}
        width="4"
        style={{ textAlign: "center", marginBottom: "10px" }}
      >
        {/* {GetILTag(r.id, data[r.id])}  */}
      </Grid.Column>
    )),
  );

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  return (
    <div style={styles.div}>
      {!electronApp && pop && (
        <RequestAccessModal
          pop={pop}
          yes={handleYes}
          no={handleNo}
          reqq={requestor.split(":")[0]}
        />
      )}
      <h1>PRE-START IO CHECKS (MAIN) </h1>
      <Grid inverted divided centered columns="equal" style={styles.grid}>
        <Grid.Column style={{ maxWidth: "1200px", padding: "0" }}>
          <Grid inverted divided centered columns="equal" style={styles.grid}>
            <Grid.Row>
              <Grid.Column>{ILColumn}</Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Column>
      </Grid>
    </div>
  );
};
const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  header: {
    marginBottom: "15px",
  },
  grid: {
    paddingBottom: "0",
    paddingTop: "20px",
    paddingLeft: "10px",
  },
};

export default IOCheckMacro_MAIN;
